<template>
  <div class="single-task">
    <SingleTaskModal v-model="isModalOpened" :slug="task.slug" :title="task.name" />

    <div
      :class="{ 'lm-progress-task__item--settings': task.hasSettings }"
      class="lm-progress-task__item"
      @click="task.hasSettings && (isModalOpened = true)"
    >
      <div
        :class="{ 'lm-progress-task__title--settings text-white': task.hasSettings }"
        class="lm-progress-task__title"
      >
        {{ task.name }}
      </div>
      <div :class="{ 'lm-progress-task__count--settings': task.hasSettings }" class="lm-progress-task__count">
        <i
          :class="{
            'fa-cog': task.hasSettings,
            'fa-ban': !task.hasSettings
          }"
          class="fa fa-cog fa-fw"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SingleTaskModal from './single-task-modal/SingleTaskModal'

export default {
  components: {
    SingleTaskModal
  },

  props: {
    task: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    isModalOpened: false
  })
}
</script>
